import ConsumerTokensList from './ConsumerTokensList';
export default ConsumerTokensList;
